const defaultState = {
  status: 'default',
  data: [],
  code: 500,
  message: '',
  id: '',
};

let response = {};
const HistoryEduSiswa_lib = (state = defaultState, action = {}) => {
  switch (action.type) {
    case 'SUCCESS_HISTORYEDUSISWA':
      response = {
        ...state,
        data: action.data ? action.data : {},
        code: action.code ? action.code : 500,
        status: 'success',
        id: action.id ? action.id : '',
        message: action.message ? action.message : '',
      };

      break;
    case 'LOADING_HISTORYEDUSISWA':
      response = {
        ...state,
        id: action.id ? action.id : '',
        status: 'loading',
      };
      break;
    case 'ERROR_HISTORYEDUSISWA':
      response = {
        ...state,
        status: 'error',
        message: action.message ? action.message : '',
        code: action.code ? action.code : 500,
      };
      break;
    default:
      return {
        ...state,
      };
  }

  return response;
};

export default HistoryEduSiswa_lib;
